













import { Component } from 'vue-property-decorator';
import SideBar from '@/components/ViewComponent/ELearning/SideBar.vue';
import HasSideDrawerMixin from '@/mixin/Layout/has-side-drawer-mixin';

@Component<ELearning>({
  components: { SideBar },
})
export default class ELearning extends HasSideDrawerMixin {}
